module.exports = __webpack_public_path__ + "static/media/user-icon.1e976c46.png";